<template>
  <div>
    <div class="flex justify-between items-center">
        <span class="font-semibold text-gray-dark">Code snippet for <code class="text-black">&lt;head&gt;</code></span>
        <div class="flex">
          <base-button variant="transparent-primary" @click="copyHeadScript">
            Copy
            <CopyIcon class="h-5 w-5" :is-copied="isHeadCodeSnippetCopied"/>
          </base-button>
        </div>
      </div>

      <PrismComponent class="rounded-lg max-h-96" language="html">{{ headCodeSnippetText }}</PrismComponent>

      <div class="mt-6 flex justify-between items-center">
        <span class="font-semibold text-gray-dark">Code snippet for <code class="text-black">&lt;body&gt;</code></span>
        <div class="flex">
          <base-button v-if="showUnreleased"
                        variant="transparent-primary"
                        @click="$emit('go-to-theme')"
          >
            Edit theme
            <PaletteIcon class="h-5 w-5"/>
          </base-button>
          <base-button variant="transparent-primary" @click="copyBodyScript">
            Copy
            <CopyIcon class="h-5 w-5" :is-copied="isBodyCodeSnippetCopied"/>
          </base-button>
        </div>
      </div>

      <PrismComponent class="rounded-lg max-h-96" language="html">{{ bodyCodeSnippetText }}</PrismComponent>
  </div>
</template>

<script>
import BaseButton from '@/components/base-components/BaseButton.vue'
import PrismComponent from 'vue-prism-component'
import 'prismjs/components/prism-javascript'
import 'prismjs/themes/prism.css'
import CopyIcon from '@/assets/images/icons/CopyIcon.vue'
import PaletteIcon from '@/assets/images/icons/PaletteIcon.vue'

export default {
  name: 'SettingsBotSnippetJavaScript',
  components: { BaseButton, PrismComponent, CopyIcon, PaletteIcon },
  props: {
    headCodeSnippetText: {
      type: String,
      required: true
    },
    bodyCodeSnippetText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isHeadCodeSnippetCopied: false,
      isBodyCodeSnippetCopied: false
    }
  },
  methods: {
    async copyHeadScript() {
      this.$copyText(this.headCodeSnippetText)
      this.isHeadCodeSnippetCopied = true
      await this.sleep(2000)
      this.isHeadCodeSnippetCopied = false
    },
    async copyBodyScript() {
      this.$copyText(this.bodyCodeSnippetText)
      this.isBodyCodeSnippetCopied = true
      await this.sleep(2000)
      this.isBodyCodeSnippetCopied = false
    }
  }
}
</script>
